// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SuperprizeTab_wrapper__z26WX {
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 12px;
  padding: 100px 32px;
  background-position: center right;
}
.SuperprizeTab_wrapper__z26WX .SuperprizeTab_title__eFQkM {
  color: #FAF9F8;
  font-size: 48px;
  font-weight: 700;
}
.SuperprizeTab_wrapper__z26WX .SuperprizeTab_description__PzQwR {
  color: #DAD6CE;
  font-size: 20px;
  font-weight: 400;
  margin-top: 24px;
  width: 50%;
  margin-bottom: 24px;
}

.SuperprizeTab_another__vl7jD {
  margin-top: 32px;
}
.SuperprizeTab_another__vl7jD .SuperprizeTab_anotherTitle__M\\+DSD {
  font-size: 32px;
  font-weight: 700;
  color: #FAF9F8;
}
.SuperprizeTab_another__vl7jD .SuperprizeTab_anotherSubtitle__gchOt {
  font-size: 20px;
  font-weight: 400;
  color: #C2BDB2;
  margin-top: 12px;
  margin-bottom: 25px;
}
.SuperprizeTab_another__vl7jD .SuperprizeTab_anotherItems__cRvuS {
  display: flex;
  gap: 16px;
  justify-content: space-between;
}
.SuperprizeTab_another__vl7jD .SuperprizeTab_anotherItems__cRvuS .SuperprizeTab_anotherItem__thPFx {
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 12px;
  padding: 17px;
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.SuperprizeTab_another__vl7jD .SuperprizeTab_anotherItems__cRvuS .SuperprizeTab_anotherItem__thPFx .SuperprizeTab_anotherItemInfo__wSzts .SuperprizeTab_anotherItemTitle__KjtHY {
  font-size: 24px;
  font-weight: 600;
  color: #FAF9F8;
}
.SuperprizeTab_another__vl7jD .SuperprizeTab_anotherItems__cRvuS .SuperprizeTab_anotherItem__thPFx .SuperprizeTab_anotherItemInfo__wSzts .SuperprizeTab_anotherItemDescription__qWKG7 {
  font-size: 18px;
  font-weight: 400;
  color: #C2BDB2;
  margin-top: 12px;
}
.SuperprizeTab_another__vl7jD .SuperprizeTab_anotherItems__cRvuS .SuperprizeTab_anotherItem__thPFx .SuperprizeTab_anotherItemImage__GGA70 img {
  width: 100px;
}

@media (max-width: 1100px) {
  .SuperprizeTab_another__vl7jD .SuperprizeTab_anotherTitle__M\\+DSD {
    font-size: 28px;
  }
  .SuperprizeTab_another__vl7jD .SuperprizeTab_anotherSubtitle__gchOt {
    font-size: 18px;
  }
  .SuperprizeTab_another__vl7jD .SuperprizeTab_anotherItems__cRvuS {
    flex-direction: column;
  }
  .SuperprizeTab_another__vl7jD .SuperprizeTab_anotherItems__cRvuS .SuperprizeTab_anotherItem__thPFx {
    width: 100%;
  }
}
@media (max-width: 800px) {
  .SuperprizeTab_wrapper__z26WX {
    background-position: center center;
    padding: 24px 16px;
  }
  .SuperprizeTab_wrapper__z26WX .SuperprizeTab_title__eFQkM {
    font-size: 22px;
  }
  .SuperprizeTab_wrapper__z26WX .SuperprizeTab_description__PzQwR {
    font-size: 16px;
    width: unset;
  }
  .SuperprizeTab_another__vl7jD .SuperprizeTab_anotherItems__cRvuS .SuperprizeTab_anotherItem__thPFx {
    flex-direction: column;
    gap: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Cybermarathon/components/SuperprizeTab/SuperprizeTab.module.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,4BAAA;EACA,mBAAA;EACA,mBAAA;EACA,iCAAA;AACF;AACE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AACJ;AAEE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,mBAAA;AAAJ;;AAIA;EACE,gBAAA;AADF;AAGE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AADJ;AAIE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AAFJ;AAKE;EACE,aAAA;EACA,SAAA;EACA,8BAAA;AAHJ;AAKI;EACE,sBAAA;EACA,4BAAA;EACA,mBAAA;EACA,aAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAHN;AAOQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AALV;AAQQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AANV;AAWQ;EACE,YAAA;AATV;;AAgBA;EAEI;IACE,eAAA;EAdJ;EAiBE;IACE,eAAA;EAfJ;EAkBE;IACE,sBAAA;EAhBJ;EAkBI;IACE,WAAA;EAhBN;AACF;AAqBA;EACE;IACE,kCAAA;IACA,kBAAA;EAnBF;EAqBE;IACE,eAAA;EAnBJ;EAsBE;IACE,eAAA;IACA,YAAA;EApBJ;EAiCI;IACE,sBAAA;IACA,SAAA;EA/BN;AACF","sourcesContent":[".wrapper {\n  background-size: cover;\n  background-repeat: no-repeat;\n  border-radius: 12px;\n  padding: 100px 32px;\n  background-position: center right;\n\n  .title {\n    color: #FAF9F8;\n    font-size: 48px;\n    font-weight: 700;\n  }\n\n  .description {\n    color: #DAD6CE;\n    font-size: 20px;\n    font-weight: 400;\n    margin-top: 24px;\n    width: 50%;\n    margin-bottom: 24px;\n  }\n}\n\n.another {\n  margin-top: 32px;\n\n  .anotherTitle {\n    font-size: 32px;\n    font-weight: 700;\n    color: #FAF9F8;\n  }\n\n  .anotherSubtitle {\n    font-size: 20px;\n    font-weight: 400;\n    color: #C2BDB2;\n    margin-top: 12px;\n    margin-bottom: 25px;\n  }\n\n  .anotherItems {\n    display: flex;\n    gap: 16px;\n    justify-content: space-between;\n\n    .anotherItem {\n      background-size: cover;\n      background-repeat: no-repeat;\n      border-radius: 12px;\n      padding: 17px;\n      width: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n\n      .anotherItemInfo {\n\n        .anotherItemTitle {\n          font-size: 24px;\n          font-weight: 600;\n          color: #FAF9F8;\n        }\n\n        .anotherItemDescription {\n          font-size: 18px;\n          font-weight: 400;\n          color: #C2BDB2;\n          margin-top: 12px;\n        }\n      }\n\n      .anotherItemImage {\n        img {\n          width: 100px;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 1100px) {\n  .another {\n    .anotherTitle {\n      font-size: 28px;\n    }\n\n    .anotherSubtitle {\n      font-size: 18px;\n    }\n\n    .anotherItems {\n      flex-direction: column;\n\n      .anotherItem {\n        width: 100%;\n      }\n    }\n  }\n}\n\n@media (max-width: 800px) {\n  .wrapper {\n    background-position: center center;\n    padding: 24px 16px;\n\n    .title {\n      font-size: 22px;\n    }\n\n    .description {\n      font-size: 16px;\n      width: unset;\n    }\n  }\n\n  .another {\n    .anotherTitle {\n    }\n\n    .anotherSubtitle {\n    }\n\n    .anotherItems {\n\n      .anotherItem {\n        flex-direction: column;\n        gap: 24px;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `SuperprizeTab_wrapper__z26WX`,
	"title": `SuperprizeTab_title__eFQkM`,
	"description": `SuperprizeTab_description__PzQwR`,
	"another": `SuperprizeTab_another__vl7jD`,
	"anotherTitle": `SuperprizeTab_anotherTitle__M+DSD`,
	"anotherSubtitle": `SuperprizeTab_anotherSubtitle__gchOt`,
	"anotherItems": `SuperprizeTab_anotherItems__cRvuS`,
	"anotherItem": `SuperprizeTab_anotherItem__thPFx`,
	"anotherItemInfo": `SuperprizeTab_anotherItemInfo__wSzts`,
	"anotherItemTitle": `SuperprizeTab_anotherItemTitle__KjtHY`,
	"anotherItemDescription": `SuperprizeTab_anotherItemDescription__qWKG7`,
	"anotherItemImage": `SuperprizeTab_anotherItemImage__GGA70`
};
export default ___CSS_LOADER_EXPORT___;
